const SOCIAL_STATS = [
  {
    icon: "/homepage/vlink.svg",
    value: "500k+",
    label: "Followers",
    alt: "LinkedIn",
  },
  {
    icon: "/homepage/vig.svg",
    value: "2M+",
    label: "Followers",
    alt: "Instagram",
  },
  {
    icon: "/homepage/vyt.svg",
    value: "650k+",
    label: "Subscribers",
    alt: "YouTube",
  },
  {
    icon: "/homepage/vt.svg",
    value: "150k+",
    label: "Followers",
    alt: "X",
  },
] as const;

export default function CuratorSection() {
  return (
    <section className="w-full bg-black py-8 font-fira md:py-20">
      <div className="mx-auto w-[90%] md:w-[80%]">
        <div className="relative overflow-hidden rounded-2xl border border-white/40 md:rounded-3xl">

          <picture className="pointer-events-none absolute inset-0">
            <source media="(min-width: 768px)" srcSet="/homepage/vmaind.webp" />
            <img
              src="/homepage/vmainm.webp"
              alt=""
              className="h-full w-full object-cover"
              loading="lazy"
              decoding="async"
            />
          </picture>
         

          <div className="relative z-10 flex min-h-[680px] flex-col px-6 py-10 sm:px-8 md:min-h-[460px] md:px-12 md:py-14 lg:px-16 lg:py-16">
            <div className="md:max-w-lg">
              <p className="mb-3 text-xs font-normal uppercase tracking-[1.75px] text-white md:mb-4 md:text-sm">
                The curator
              </p>
              <h2 className="mb-4 font-fira-condensed text-[32px] font-medium leading-tight tracking-tight text-white md:mb-6 md:text-[42px]">
                Behind the signal
              </h2>
              <p className="text-[14px] font-normal leading-relaxed text-[#FFFFFF85] md:text-[16px]">
                Hi, I&apos;m Vaibhav Sisinty, Founder, GrowthSchool— trained
                10M+ learners across 150+ countries. Staying Ahead started as
                me sharing what I was learning each week. It grew because
                people wanted AI updates from a person, not a feed.
              </p>
            </div>

            <div className="mt-auto grid grid-cols-2 gap-3 pt-10 md:mt-10 md:max-w-xl md:gap-4 md:pt-0">
              {SOCIAL_STATS.map(({ icon, value, label, alt }) => (
                <div
                  key={alt}
                  className="flex items-center gap-3 rounded-lg border border-white/15 bg-black/40 px-3 py-2.5 backdrop-blur-sm md:gap-4 md:px-4 md:py-3"
                >
                  <img
                    src={icon}
                    alt={alt}
                    className="h-4 w-4 shrink-0 object-contain md:h-[18px] md:w-[18px]"
                  />
                  <span
                    className="h-4 w-px shrink-0 bg-white/20"
                    aria-hidden
                  />
                  <p className="text-xs md:text-sm">
                    <span className="font-semibold text-white">{value}</span>
                    <span className="text-white/70"> {label}</span>
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
